<template lang="pug">
    include DashboardRegistry.pug
</template>

<script>

export default {
    name: 'DashboardRegistry',
    data() {
        return {
        };
    }
}

</script>

<style scoped lang="scss">
@import "DashboardRegistry";
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardRegistry.vue